// gloss
export const MAX_PAGE_SIZE = 10000;

// gloss
export const SURVEY_ANSWERS_MAX_PAGE_SIZE = 20;
